// extracted by mini-css-extract-plugin
module.exports = {"list-item":"sync_list-item__3qwZ2","list-item__meta":"sync_list-item__meta__37R76","list-item__chevron":"sync_list-item__chevron__2LdGL"};